module.exports = __webpack_public_path__ + "img/equipment_20pt.bb1ce7cb.svg";